import { FormLayout } from '@formily/antd';
import { createVoidSchemaComponent } from '../../shared';
const FormilyFormLayout = createVoidSchemaComponent({
    componentName: 'FormLayout',
    component: FormLayout,
});
export default FormilyFormLayout;
